module.exports = __webpack_public_path__ + "img/product_94.f5bfd14.webp";